import { React, useEffect, useState, useCallback } from "react";
import styles from "./CalculoIMC.module.css";

import imcImgBaixo from "../../../Assets/imcImg/baixo-peso.png";
import imcImgAdequado from "../../../Assets/imcImg/peso-adequado.png";
import imcImgSobre from "../../../Assets/imcImg/sobre-peso.png";
import imcImgObesidade from "../../../Assets/imcImg/obesidade.png";

const CalculoIMC = () => {
  const [altura, setAltura] = useState("");
  const [peso, setPeso] = useState("");
  const [resultadoCalculo, setResultadoCalculo] = useState("");
  const [resultado, setResultado] = useState("");
  const [calculou, setCalculou] = useState(false);

  const [resultado2ComStrong, setResultado2ComStrong] = useState("");

  const [VerificarBaixo, setVerificarBaixo] = useState(false);
  const [VerificarAdequado, setVerificarAdequado] = useState(false);
  const [VerificarSobre, setVerificarSobre] = useState(false);
  const [VerificarObesidade, setVerificarObesidade] = useState(false);

  const [VerificarInputs, SetVerificarInputs] = useState(false);
  const [verificaInputAltura, setVerificaInputAltura] = useState(false);
  const [verificaInputPeso, setVerificaInputPeso] = useState(false);

  const [paraVerificarOdirecionamento, setParaVerificarOdirecionamento] =
    useState(false);

  const [alturaParaMostrarNaTela, setAlturaParaMostrarNaTela] = useState("");
  const [pesoParaMostrarNaTela, setPesoParaMostrarNaTela] = useState("");

  const calcularImc = () => {
    if (altura !== "" && peso !== "") {
      const alturaNum = parseFloat(altura.replace(",", "."));
      const pesoNum = parseFloat(peso.replace(",", "."));

      const imcCalculado = pesoNum / (alturaNum * alturaNum);

      setResultadoCalculo(imcCalculado.toFixed(2));
      classificaImc(imcCalculado);

      setCalculou(true);
      setAlturaParaMostrarNaTela(altura);
      setPesoParaMostrarNaTela(peso);

      setAltura("");
      setPeso("");

      SetVerificarInputs(false);
      setVerificaInputAltura(false);
      setVerificaInputPeso(false);
      setParaVerificarOdirecionamento(true);
    } else {
      SetVerificarInputs(true);

      setVerificaInputAltura(altura === "");
      setVerificaInputPeso(peso === "");

      setParaVerificarOdirecionamento(false);
    }
  };

  const classificaImc = (imc) => {
    if (imc < 18.5) {
      setVerificarBaixo(true);
      setVerificarAdequado(false);
      setVerificarSobre(false);
      setVerificarObesidade(false);

      setResultado("Seu IMC é menor que 18.5, isso quer dizer que você está ");
      setResultado2ComStrong("abaixo do peso.");
    } else if (imc < 25) {
      setVerificarBaixo(false);
      setVerificarAdequado(true);
      setVerificarSobre(false);
      setVerificarObesidade(false);

      setResultado("Seu IMC está entre 18.5 e 24.9, isso quer dizer que você está no ");
      setResultado2ComStrong("peso ideal.");
    } else if (imc < 29.9) {
      setVerificarBaixo(false);
      setVerificarAdequado(false);
      setVerificarSobre(true);
      setVerificarObesidade(false);

      setResultado("Seu IMC está entre 25 e 29.9, isso quer dizer que você está ");
      setResultado2ComStrong("acima do peso.");
    } else {
      setVerificarBaixo(false);
      setVerificarAdequado(false);
      setVerificarSobre(false);
      setVerificarObesidade(true);

      setResultado("Seu IMC é maior que 30, isso quer dizer que você está em níveis de ");
      setResultado2ComStrong("obesidade.");
    }
  };

  const handleKeyUpAltura = useCallback((e) => {
    e.currentTarget.maxLength = 4;

    let value = e.currentTarget.value;
    value = value.replace(/[^0-9.,]/g, "");
    value = value.replace(/^(\d{1})(\d)/, "$1.$2");

    e.currentTarget.value = value;
    setAltura(value);
  }, []);

  const handleKeyUpPeso = useCallback((e) => {
    e.currentTarget.maxLength = 6;

    let value = e.currentTarget.value;
    value = value.replace(/[^0-9.,]/g, "");

    e.currentTarget.value = value;
    setPeso(value);
  }, []);

  useEffect(() => {}, []);

  const retornoImc = calculou ? `Seu IMC é: ${resultadoCalculo}` : "";
  const retornoClassificacao = calculou ? resultado : "";

  return (
    <section className={styles.calculoImcContainer}>

      {/* 🔥 SEO TOPO (NÃO INTERFERE NA FERRAMENTA) */}
      <div className={styles.seoHeader}>
        <h1>Calculadora de IMC Online Grátis</h1>
        <p>
          Calcule seu Índice de Massa Corporal (IMC) de forma rápida e descubra
          se você está no peso ideal, acima ou abaixo do recomendado.
        </p>
      </div>

      {/* 🔥 SUA FERRAMENTA (INALTERADA) */}
      <div className={styles.boxcalculoImc}>
        <div className={styles.boxParaFundo}>
          <h3>Calcular seu IMC</h3>

          <label>Altura</label>
          <input
            className={`${styles.inputAltura} ${
              verificaInputAltura ? styles.colorInputAltura : ""
            }`}
            placeholder="Ex: 1,70"
            onKeyUp={handleKeyUpAltura}
            value={altura}
            onChange={(e) => setAltura(e.target.value)}
          />

          <label>Peso</label>
          <input
            className={`${styles.inputPeso} ${
              verificaInputPeso ? styles.colorInputPeso : ""
            }`}
            placeholder="Ex: 65"
            onKeyUp={handleKeyUpPeso}
            value={peso}
            onChange={(e) => setPeso(e.target.value)}
          />

          {VerificarInputs && (
            <p className={styles.VerificacaoInput}>
              Preencha todos os campos!
            </p>
          )}

          <button className={styles.btnCalcular} onClick={calcularImc}>
            Calcular
          </button>

          <div className={styles.boxIMGs}>
            <img className={styles.imcImg} src={imcImgBaixo} />
            <img className={styles.imcImg} src={imcImgAdequado} />
            <img className={styles.imcImg} src={imcImgSobre} />
            <img className={styles.imcImg} src={imcImgObesidade} />
          </div>

          <div className={styles.containerResulte}>
            <div
              className={`${styles.boxInfo} ${
                VerificarBaixo ? styles.colorBaixo : ""
              } ${VerificarAdequado ? styles.colorAdequado : ""} ${
                VerificarSobre ? styles.colorSobre : ""
              } ${VerificarObesidade ? styles.colorObesidade : ""}`}
            >
              <h4>{retornoImc}</h4>
              <p>
                {retornoClassificacao}{" "}
                <strong>{resultado2ComStrong}</strong>
              </p>
            </div>

            <div className={styles.boxImg}>
              {VerificarBaixo && (
                <img className={styles.imcImg} src={imcImgBaixo} />
              )}
              {VerificarAdequado && (
                <img className={styles.imcImg} src={imcImgAdequado} />
              )}
              {VerificarSobre && (
                <img className={styles.imcImg} src={imcImgSobre} />
              )}
              {VerificarObesidade && (
                <img className={styles.imcImg} src={imcImgObesidade} />
              )}

              <div className={styles.boxValueAlturaEpeso}>
                {paraVerificarOdirecionamento && (
                  <>
                    <div className={styles.boxValueAltura}>
                      <strong>{alturaParaMostrarNaTela}</strong>
                      <p>h</p>
                    </div>
                    <div className={styles.boxValuePeso}>
                      <strong>{pesoParaMostrarNaTela}</strong>
                      <p>kg</p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔥 SEO CONTEÚDO FINAL */}
      <div className={styles.seoContent}>
        <h2>O que é IMC?</h2>
        <p>
          O IMC (Índice de Massa Corporal) é um cálculo utilizado para avaliar
          se uma pessoa está dentro do peso ideal em relação à sua altura.
        </p>

        <h2>Tabela de IMC</h2>
        <ul>
          <li>Abaixo de 18.5 → Abaixo do peso</li>
          <li>18.5 a 24.9 → Peso ideal</li>
          <li>25 a 29.9 → Sobrepeso</li>
          <li>30 ou mais → Obesidade</li>
        </ul>

        <p className={styles.disclaimer}>
          Este cálculo é apenas uma estimativa e não substitui avaliação médica.
        </p>
      </div>

      <div className={styles.containerAfiliados}>
        <div id="BoxAfiliadosId" className={styles.BoxAfiliados}></div>
      </div>
    </section>
  );
};

export default CalculoIMC;